<script lang="ts">
	import type { SvelteSet } from 'svelte/reactivity'
	import type { SearchField } from 'utility/search-fields'
	import { graphql } from '$houdini'
	import { onMount, type ComponentProps } from 'svelte'
	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import Pin from 'components/search/Pin.svelte'

	interface Props extends Omit<ComponentProps<typeof Autocomplete<string | null>>, 'options' | 'value' | 'emptyValue'> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: Set<SearchField['key']> //Required
		titleStatus?: string | null
		label?: string
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		titleStatus = $bindable(null),
		label = 'Title Status',
		...rest
	}: Props = $props()

	let titleStatuses: string[] = $state([])

	const getTitleStatusQuery = graphql(`
		query VehicleTitleStatuses {
			vehicleTitleStatuses
		}
	`)

	onMount(async () => {
		const res = await getTitleStatusQuery.fetch({ policy: 'CacheOrNetwork' })
		titleStatuses = res.data?.vehicleTitleStatuses ?? []
	})
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Autocomplete
		{...rest}
		{label}
		options={titleStatuses}
		bind:value={titleStatus}
		emptyValue={null}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Autocomplete>
</EditModeControls>
